<template>
  <div>
    <!-- Delete Model -->
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteUser" />

    <!-- Search -->
    <b-card no-body>
      <!-- Search Patient Name -->
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.search") }}</h2>
            <br />
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="6" cols="12">
            <h4>{{ $t("common.patient-name") }}</h4>
            <b-form-group :label="$t('common.patient-name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('common.patient-name')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="1">
            <br />
          </b-col>
          <!-- add Patient's Mother name -->
          <!-- we can delete the spaces created by the errors handler using the br below -->
          <!-- <br v-if="!errorForm.first_name && !errorForm.second_name && !errorForm.third_name && !errorForm.forth_name " />  -->
          <b-col md="5" cols="12">
            <h4>{{ $t("reception.patient-mother-name") }}</h4>
            <b-form-group
              :label="$t('reception.patient-mother-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientMotherName"
                :placeholder="$t('reception.patient-mother-name')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="index()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Data Table  -->
      <b-table
        :items="this.patientsData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="No matching patients found"
        class="position-relative"
        v-if="!loading"
      >
        <!-- Column: Phone -->
        <template #cell(Phone)="data">
          <span class="text-nowrap">
            {{ data.item.phone }}
          </span>
        </template>
        <!-- <template #cell(name)="data">
  
          </template> -->
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap d-flex">
            <!-- @click="printId(data.item.id)" -->
            <b-button
              class="button-preview"
              @click="
                $router.push({
                  name: 'Reception-patient-preview',
                  params: { id: data.item.id },
                })
              "
              :variant="data.item.is_dead ? 'danger' : ''"
              >{{ $t("common.preview") }}
            </b-button>
            <ActionsButtons
              :noEdit="true"
              deletePerm="delete-patient"
              editPerm="update-patient"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            />
          </div>
        </template>
      </b-table>

      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing 1 to 10 patients</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="index()"
          >
            <b-pagination
              v-model="page"
              :total-rows="this.pathientsNumber"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
  <!-- Table Container Card -->
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIcon,
  BIconSearch,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

export default {
  mixins: [permissionChecker],
  components: {
    DeleteModal,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BIcon,
    BIconSearch,
    BSpinner,
    BModal,
    BAlert,
    ActionsButtons,
    BCardText,
    StatisticCardHorizontal,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },

  data() {
    return {
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "patient_no",
          label: this.$t("reception.patient-no"),
          sortable: true,
        },

        {
          key: "birth_date",
          label: this.$t("reception.birth-date"),
          sortable: true,
        },
        { key: "Phone", label: this.$t("reception.phone"), sortable: true, class: "text-nowrap" },
        {
          key: "mother_name",
          label: this.$t("reception.patient-mother-name"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      patientName: "",
      patientMotherName: "",
      EditForm: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        nickname: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        phone: "",
        second_phone: "",
        age: "",
        adderss: "",
        _method: "PUT",
      },
      errorForm: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        nickname: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        card_type: "",
        phone: "",
        second_phone: "",
        age: "",
        adderss: "",
        birthday: "",
        city_id: "",
      },
      take: 10,
      loading: true,
      selected: "",
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      params: {
        form: {},
        path: "",
      },
      cities: [],
      city: "",
      patientsData: [],
      pathientsNumber: 0,
      deleteForm: [],
      statusFilter: null,
      filterData: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        patient_id: "",
        nickname: "",
      },
    };
  },
  mounted() {
    this.index();
  },
  methods: {
    show(item) {
      this.EditForm.id = item.id;
      this.EditForm.first_name = item.first_name;
      this.EditForm.second_name = item.second_name;
      this.EditForm.third_name = item.third_name;
      this.EditForm.forth_name = item.forth_name;
      this.EditForm.nickname = item.nickname;
      this.EditForm.first_mother_name = item.first_mother_name;
      this.EditForm.second_mother_name = item.second_mother_name;
      this.EditForm.third_mother_name = item.third_mother_name;
      this.EditForm.forth_mother_name = item.forth_mother_name;
      this.EditForm.national_id = item.national_id;
      this.EditForm.phone = item.phone;
      this.EditForm.second_phone = item.second_phone;
      this.EditForm.age = item.age;
      this.EditForm.adderss = item.adderss;
      // if (this.requestPermission.includes("get-city")) {
      //   // this.getCities();
      // } else {
      //   this.cities = ["Baghdad", "Basra", "Erbil", "Mosul", "Najaf", "Not Specified"];
      // }
      this.$bvModal.show("modal-edit");
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    async index() {
      // after each time the search button being pressed the loading should be back again
      this.loading = true;
      // check if there are any null value in the obj we sending
      for (const [key, value] of Object.entries(this.filterData)) {
        if (value == null) {
          this.filterData[key] = "";
        }
      }
      await this.getList(
        `/patient?page=${this.page}&take=${this.take}&sort=-id`
      );
      this.pathientsNumber = this.all_data.total;
      this.patientsData = this.all_data.data;
      this.loading = false;
    },

    // async getCities() {
    //   await this.getList(`/city`);
    //   for (let item in this.all_data.data) {
    //     this.cities.push(this.all_data.data[item].name);
    //   }
    // },
    updateItem() {
      if (this.city) {
        this.EditForm.city_id = (this.cities.indexOf(this.city) + 1).toString();
      }
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      (this.params.form = this.EditForm),
        (this.params.path = `/patient/${this.EditForm.id}`),
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.index();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    setName(name, value, blur) {
      if (blur != "blur") {
        this.nameValue = value;
      }
      if (blur == "blur") {
        this.addForm[name] = this.nameValue;
      }
    },
    deleteUser() {
      this.$store
        .dispatch("delete", `/patient/${this.deleteForm.id}`)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
